export enum DiseaseType {
HIGH_PRESSURE = "HIGH_PRESSURE",
CARDIOVASCULAR_DISEASE = "CARDIOVASCULAR_DISEASE",
DIABETES = "DIABETES",
CKD = "CKD",
HIGH_COLESTEROL = "HIGH_COLESTEROL",
STROKE = "STROKE",
MENTAL_HEALTH = "MENTAL_HEALTH",
HEARTH_ATTACK = "HEARTH_ATTACK"
}